<template>
  <div class="px-1 py-3">
    <v-expansion-panels
      v-model="panel"
      multiple
    >
      <v-expansion-panel
        v-for="socialMedia of socialMedias"
        :key="socialMedia.id"
      >
        <v-expansion-panel-header>
          <div>
            <p-social-media-icon
              :id="socialMedia.id"
              large
              left
            ></p-social-media-icon>
            {{ socialMedia.name }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-12">
          <v-list-item
            v-for="channel of socialMediaChannelsById(socialMedia.id)"
            :key="channel.id"
            class="px-0"
          >
            <v-list-item-avatar
              color="primary lighten-2"
              size="26"
            >
              <span class="white--text text-title">{{ channel.name[0] }}</span>
            </v-list-item-avatar>
            <v-list-item-content>
              {{ channel.name }}
            </v-list-item-content>
            <v-list-item-action v-if="hasAccess()">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    @click="removeSocialMediaChannel(channel)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('remove')  }}</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <v-btn
            v-if="hasAccess()"
            color="primary"
            class="mt-4"
            outlined
            @click="addSocialMediaChannel(socialMedia.id)"
          >
            {{ $t('marketing.addSocialMediaChannel') }}
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

import PSocialMediaIcon from '@/components/PSocialMediaIcon'

import socialMediaChannelMixin from '@/mixins/socialMediaChannel.mixin'
import pageMixin from '@/mixins/page.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PSocialMediaIcon
  },


  mixins: [
    socialMediaChannelMixin,
    pageMixin,
    accessMixin
  ],


  data () {
    return {
      panel: [0]
    }
  },


  computed: {
    ...mapGetters('socialMedia', ['socialMedias']),
    ...mapGetters('socialMediaChannel', ['socialMediaChannelsById'])
  }
}
</script>
